import { render, staticRenderFns } from "./ReturnList.vue?vue&type=template&id=72fb2b67&scoped=true&"
import script from "./ReturnList.vue?vue&type=script&lang=js&"
export * from "./ReturnList.vue?vue&type=script&lang=js&"
import style0 from "./ReturnList.vue?vue&type=style&index=0&id=72fb2b67&lang=scss&scoped=true&"
import style1 from "./ReturnList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fb2b67",
  null
  
)

export default component.exports